import queryString from "query-string";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router";

import { useLocationDocument } from "../../api/firestoreWrappers.generated.jsx";
import Header from "../../components/Header/Header";
import CorvusMap from "../../components/Map";

export default function MapPage() {
    const { organizationId, locationId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {
        flightId,
        missionId,
        droneId,
        taskId,
        x,
        y,
        highlightedDockId,
        inspect,
    } = queryString.parse(location.search);
    const [locationDoc] = useLocationDocument(organizationId, locationId);
    const taskPreview = taskId && droneId ? { taskId, droneId } : {};
    const resumePreview = missionId && droneId ? { missionId, droneId } : {};
    const point =
        !Number.isNaN(Number(x)) && !Number.isNaN(Number(y))
            ? { x: Number(x), y: Number(y) }
            : null;

    function handleInspectChange(nextInspect) {
        const query = queryString.parse(location.search);
        if (nextInspect) {
            query.inspect = null;
        } else {
            delete query.inspect;
        }

        const search = queryString.stringify(query);
        navigate({ search: search ? `?${search}` : "" }, { replace: true });
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
            }}
        >
            <Header style={{ maxWidth: "850px" }} />
            <Container
                fluid
                className="p-0"
                style={{ flexGrow: 1, overflow: "hidden" }}
            >
                <title>{`Map ${locationDoc?.name} | MyCorvus`}</title>
                <CorvusMap
                    organizationId={organizationId}
                    locationId={locationId}
                    flightId={flightId}
                    missionId={missionId && !droneId ? missionId : undefined} // Don't show mission overview when resumePreview is shown
                    taskPreview={taskPreview}
                    resumePreview={resumePreview}
                    point={point}
                    highlightedDockId={highlightedDockId}
                    inspect={
                        inspect !== undefined &&
                        inspect?.toLowerCase() !== "false"
                    }
                    onInspectChange={handleInspectChange}
                />
            </Container>
        </div>
    );
}
